import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { ApiService } from 'app/main/shared/services/api.service';
import { AuthService } from '../shared/services/auth.service';
import { LocalAccountService } from '../shared/services/localAccount.service';

@Injectable({
  providedIn: 'root'
})
export class SurveyService implements Resolve<any> {

  async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {


    if (state.url.includes('first-step')) {
      try {
        const resolved = {
          survey: {},
          surveyId: null
        };
        let res: any;
        const loggedIn = this.authservice.loggedIn();
        let surveyId;
        if (loggedIn) {
          if (this.localAccountService.isAdmin() || this.localAccountService.isOperator()) {
            if (route.queryParams.surveyId) {
              res = await this.getSurvey(route.queryParams.surveyId)
                .catch((err) => {
                  console.error(err);
                });
              surveyId = route.queryParams.surveyId;
            } else {
              res = await this.getTheOnlyOneActive()
                .catch((err) => {
                  console.error(err);
                });
            }
          } else if (this.localAccountService.isStudent()) {
            res = await this.getTheOnlyOneActive()
              .catch((err) => {
                console.error(err);
              });
          } else if (this.localAccountService.isProfessor()) {
            return this.router.navigateByUrl('/public-area/redirect');
          }
        } else {
          res = await this.getTheOnlyOneActivePublic()
            .catch((err) => {
              console.error(err);
            });
        }
        if (res) {
          if (res.ok) {
            resolved.survey = res.payload;
            resolved.surveyId = surveyId;
          }
        }
        if (!resolved.survey) {
          this.router.navigateByUrl(``);
        }
        return resolved;
      } catch (err) {
        this.router.navigateByUrl(``);
      }
    } else if (state.url.includes('gestione_survey')) {
      try {
        let resolved: any = {};
        const res: any = await this.retrieveSurveysByFilterPaged('', 0, 10).catch((err) => {
          console.error(err);
          resolved = {
            list: [],
            count: 0
          };
        });
        if (res) {
          if (res.ok) {
            resolved = {
              list: res.payload,
              count: res.payload.length
            };
          }
        }
        return resolved;
      } catch (err) {
        this.router.navigateByUrl(``);
      }
    }
  }

  constructor(
    private api: ApiService,
    private router: Router,
    private localAccountService: LocalAccountService,
    private authservice: AuthService
  ) {
  }

  async retrieveSurveysByFilterPaged(filterValue, pageIndex, pageSize) {
    return await this.api.getRequestPromise(`survey?filterString=${filterValue}&pageIndex=${pageIndex}&pageSize=${pageSize}`);
  }

  async getTheOnlyOneActive() {
    return await this.api.getRequestPromise(`survey/theActive`);
  }

  async getTheOnlyOneActivePublic() {
    return await this.api.getRequestPromise(`public/survey/theActive`);
  }

  async activateSurvey(surveyId) {
    return await this.api.putRequestPromise(`survey/${surveyId}/activate`, {});
  }

  async createSurvey(survey) {
    return await this.api.postRequestPromise(`survey`, survey);
  }

  async getSurvey(surveyId) {
    return await this.api.getRequestPromise(`survey/${surveyId}`);
  }

  async bestMatch(surveyId, softskillNames: Array<string>, answers: string) {
    const payload: any = {};
    payload.softskillNames = softskillNames;
    payload.answers = answers;
    return this.api.postRequestPromise(`survey/${surveyId}/bestmatch`, payload);
  }

  async bestMatchForUserWhoHasAlreadyPurchased(softskillNames: Array<string>) {
    const payload: any = {};
    payload.softskillNames = softskillNames;
    return this.api.postRequestPromise(`survey/bestmatch`, payload);
  }

  async bestMatchPublic(surveyId, softskillNames: Array<string>, answers: string) {
    const payload: any = {};
    payload.softskillNames = softskillNames;
    payload.answers = answers;
    return this.api.postRequestPromise(`public/survey/${surveyId}/bestmatch`, payload);
  }

  async getRedirectionConfig() {
    return await this.api.getRequestPromise(`public/redirectionConfig`);
  }

}
